import React from 'react';

import NabEdgeLogo from '../../assets/images/edge.svg';
import { testIds } from './LogoComponent.constants';
import { LogoContainer } from './styles';

export const LogoComponent: React.FC = () => {
    const logoElement = (
        <LogoContainer>
            <NabEdgeLogo data-test-id={testIds.LogoComponent} />
        </LogoContainer>
    );
    return logoElement;
};
